/** @format */

import React, { useMemo } from 'react';
import I18n from '../../../components/Translate/I18n';
import oplAppStyle from '../../../assets/themes/OPL/jss/App/OplAppStyle';
import withStyles from '@material-ui/core/styles/withStyles';
import KsefErrorData, { KsefErrorDataByDate } from '../../../interfaces/ksef/KsefErrorData';

type KsefErrorShortDescriptionType = {
    classes: any;
    ksefErrorDataByDate: KsefErrorDataByDate;
};

export const KsefErrorShortDescription = (props: KsefErrorShortDescriptionType): React.ReactElement => {
    const classes         = props.classes;
    const latestErrorDate = useMemo((): KsefErrorData | null => {
        const latestKey = Object.keys(props.ksefErrorDataByDate)
            .sort((a, b) => b.localeCompare(a))[0];

        if (latestKey) {
            return props.ksefErrorDataByDate[latestKey];
        }

        return null;
    }, [props.ksefErrorDataByDate]);

    return (
        <>
            {latestErrorDate && (
                <>
                    {latestErrorDate.internalError && (
                        <>
                            <I18n trans={"documents:invoices.ksefErrorParser.internal_error"}/>: <I18n trans={'documents:invoices.ksefErrorParser.'+latestErrorDate.internalError}/>
                        </>
                    )}
                    {latestErrorDate?.packageError?.description && (
                        <>
                            <I18n trans={"documents:invoices.ksefErrorParser.package_error"}/>: {latestErrorDate?.packageError?.description}<br/>
                        </>
                    )}
                    {latestErrorDate?.rejectedInvoice?.ksefFailure?.description && (
                        <>
                            <I18n
                                trans={"documents:invoices.ksefErrorParser.rejected_invoice"}/>: {latestErrorDate?.rejectedInvoice?.ksefFailure?.description}
                        </>
                    )}
                </>
            )
            }
        </>
    );
}

export default withStyles(oplAppStyle)(KsefErrorShortDescription);
